import { BadImplementationException, MUSTNeverHappenException } from '@nu-art/ts-common';
import { ModuleFE_Book, Renderer_BookFullName } from '../book/index.js';
export const resolveReferenceDisplay = (ref) => {
    if (!ref.type)
        throw new BadImplementationException('Can not resolve display for a typeless reference');
    const renderer = RefRendererMap[ref.type];
    return renderer(ref);
};
const bookRenderer = (v, b) => {
    if (!b)
        throw new BadImplementationException('Must pass book to render book display');
    const bookRef = v;
    let str = '';
    if (bookRef.data.page && bookRef.data.paragraph) {
        str += `${b.name.split(' ')[0]} `;
        if (bookRef.data.page && bookRef.data.page >= 0)
            str += `(Pg.${bookRef.data.page}) `;
        if (bookRef.data.paragraph && bookRef.data.paragraph.length > 0)
            str += `- ${bookRef.data.paragraph} `;
    }
    else
        str = Renderer_BookFullName(bookRef, b);
    return str;
};
const refDataIdRenderer = (ref) => ref.data.id;
const articleRenderer = (ref) => `${ref.data.name} - ${ref.data.journal} - ${ref.data.publicationYear}`;
const upToDateRenderer = (ref) => ref.data.name;
const RefRendererMap = {
    'snomed': refDataIdRenderer,
    'loinc': refDataIdRenderer,
    'icdCode': refDataIdRenderer,
    'cpt': refDataIdRenderer,
    'rxCUI': refDataIdRenderer,
    'atc': refDataIdRenderer,
    'article': articleRenderer,
    'upToDate': upToDateRenderer,
    'book': (ref) => {
        const book = ModuleFE_Book.cache.unique(ref.data.bookId);
        if (!book)
            throw new MUSTNeverHappenException(`Could not find book for id ${ref.data.bookId}`);
        return bookRenderer(ref, book);
    }
};
//# sourceMappingURL=resolve-reference-display.js.map